/* * 评论列表 * 作者：高苗飞 */
<template>
  <div class="root-discuss-list">
    <ScrollView ref="scrollView" class="scroll-view-wrapper" style="overflow: hidden;" :click="true" :probeType="1" :data="commentList" :pullup="pullup" @scrollToEnd="scrollToEnd">
      <div>
        <DiscussCard v-for="(item, index) in commentList" :key="index" :isFinalPage="isFinalPage" :dataSource="item" />
        <!-- <div class="act-date act-pad18 act-center" v-if="!isFinalPage">下拉加载更多</div>
        <div class="act-date act-pad18 act-center" v-else>没有更多了...</div> -->
        <NoMoreData :hasMoreData="hasMoreData"></NoMoreData>
        <div class="act-date  act-center" style="height:4rem"></div>
      </div>
    </ScrollView>
    <form action="" class="ui-listInput" :class="isIphonex ? 'ui-listInput-iphoneX' : ''">
      <div class="act-table ui-inputBg" @click="send">
        <div class="table-cell" :style="isIphonex ? 'padding-left: 1rem;' : ''">
          <div class="ui-inputbtn"><img class="act-htg36 table-cell" src="../assets/write.png" /></div>
        </div>
        <div class="table-cell" style="line-height: 100%;">
          <input ref="inputEle1" type="text" disabled placeholder="发表评论…" class="ui-send ui-send1" maxlength="500" />
        </div>
        <div class="table-cell ui-sendBtn">
          <p>发布</p>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import ScrollView from '@/components/ScrollView.vue';
import DiscussCard from '@/buscomponents/DiscussCard.vue';
import request from '@/util/request';
import { shareInit, HideShare } from '@/util/share';
import { isIphonex } from '@/util/common';
import { messages } from '@/config';
import NoMoreData from '@/buscomponents/NoMoreData.vue';
import login from '@/util/login';

export default {
  name: 'DiscussListPage',
  created() {
    this.isLogin = this.$route.query.isLogin;
    this.loadMoreData();
    console.log(this.offsetHeight);
  },
  components: {
    ScrollView,
    DiscussCard,
    NoMoreData
  },
  data() {
    return {
      isLogin: 'true',
      pullup: true,
      intervals: '',
      list: [],
      commentList: [],
      lastId: 0,
      isFinalPage: false,
      share1: {
        talk: ''
      },
      isIphonex: isIphonex() ? true : false,
      offsetHeight: document.body.offsetHeight,
      bfscrolltop: 0,
      hasMoreData: false
    };
  },
  mounted() {
    const defaultOption = {
      shareURL: window.location.href,
      shareImgSrc: 'https://img12.360buyimg.com/jrpmobile/jfs/t28069/118/1531685442/19730/8e0317ae/5ce36be5Nf2ce9f2c.png',
      shareTitle: messages.shareTitle,
      shareDesc: messages.shareDesc,
      shareChannels: ['0', '1', '3']
    };
    shareInit(defaultOption);
    // $(window).resize(() => {
    //   this.$alert.show({ content: window.innerHeight });
    // });
    HideShare({ title: '全部评论', moreItem: true, hideTools: false, backColor: '#ffffff', textColor: 2 });
  },
  methods: {
    refresh() {
      setTimeout(() => {
        this.$refs.scrollView.refresh();
      }, 300);
    },
    scrollToEnd() {
      console.log('loadMoreData');
      this.loadMoreData();
    },
    loadMoreData() {
      !this.isFinalPage && this.load(1);
    },
    load(i) {
      this.$loading.show();
      let activityId = +this.$route.query.activityId || 0;
      let lastId = i > 0 ? +this.lastId : 0;
      i == 0 && (this.commentList = []);
      let arr = [];
      request.getCommentList({
        data: {
          activityId: activityId,
          lastId: lastId
        },
        success: rs => {
          this.$loading.hide();
          arr = rs.commentList;
          this.isFinalPage = rs.isFinalPage;
          this.isLogin = rs.isLogin;
          if (rs.isFinalPage) {
            this.hasMoreData = false;
          } else {
            this.hasMoreData = true;
          }
          rs.commentList.length > 0 && (this.lastId = rs.commentList[rs.commentList.length - 1].commentId);
          this.commentList = this.commentList.concat(arr);
        }
      });
    },
    toLogin() {
      login();
    },
    send() {
      var me = this;
      // var winHtg = me.offsetHeight;
      // var scrollTop = document.body.scrollTop;
      var activityId = +me.$route.query.activityId;
      this.isLogin ? this.$router.push({ path: 'comment', query: this.$route.query }) : this.toLogin();
      // var ua = navigator.userAgent.toLowerCase();
      // winHtg: 553        553
      // scrollTop: 553     887
      // bfscrollTop: 0     553
      // if (me.share1.talk.length < 1) {
      //   me.$toast.show({ text: '评论不能为空' });
      //   return;
      // }
      // request.addComment({
      //   data: {
      //     content: me.share1.talk,
      //     activityId: activityId,
      //     deviceId: 'test deviceId'
      //   },
      //   success: rs => {
      //     if (rs.issuccess == '1') {
      //       me.$toast.show({ text: '评论成功' });
      //       $('input.ui-send1').blur();
      //       me.share1.talk = '';
      //       me.load(0);
      //     } else {
      //       this.$toast.show({ text: rs.error_msg || '系统繁忙，小伙伴请稍后再试！' });
      //       $('input.ui-send1').blur();
      //       me.share1.talk = '';
      //     }
      //   },
      //   error: msg => {
      //     window.clearTimeout(this.interval);
      //     this.$toast.show({ text: msg });
      //     $('input.ui-send1').blur();
      //     me.share1.talk = '';
      //   }
      // });
    }
    // done() {
    //   if ($.device && $.device.ios) {
    //     //获取软键盘唤起前浏览器滚动部分的高度
    //     this.bfscrolltop = document.body.scrollTop;

    //     const sst = window.setTimeout(function() {
    //       clearTimeout(sst);
    //       //设置一个计时器，时间设置与软键盘弹出所需时间相近
    //       document.body.scrollTop = document.body.scrollHeight;
    //       //获取焦点后将浏览器内所有内容高度赋给浏览器滚动部分高度
    //       $('input.ui-send1').focus();
    //     }, 350);
    //   }

    //   this.refresh();
    // },
    // blur() {
    //   if ($.device && $.device.ios) {
    //     const sst = setTimeout(() => {
    //       clearTimeout(sst);
    //       document.body.scrollTop = this.bfscrolltop;
    //     }, 350);
    //   }
    //   this.refresh();
    // }
  },
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>
<style lang="scss" scoped>
@import './../scss/mixin.scss';

.root-discuss-list {
  width: 100%;
  height: 100%;
}

.scroll-view-wrapper {
  // position: fixed !important;
  z-index: 10;
}
.act-center {
  text-align: center;
  color: #c2c2c2;
  font-size: $rem24;
}
.act-flex {
  display: flex;
}

.ui-listInput {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: $rem120;
  overflow: hidden;
  z-index: 999;
}

.ui-listInput-iphoneX {
  height: $rem158;
}

.ui-inputBg {
  // position: absolute;
  // bottom: 0;
  // left: 0;
  // z-index: 1;
  width: 100%;
  height: 100%;
  align-content: center;
  align-items: center;
  justify-content: center;
  padding: 0 $rem24;
  background: #ffffff;
  border-top: 1px solid #f7f7f7;
}

// .ui-inputBgx {
//   background: #ffffff;

//   width: 100%;
//   align-content: center;
//   align-items: center;
//   justify-content: center;
//   padding: $rem24 0 $rem62 0;
//   border-top: 1px solid #f7f7f7;
// }

.table-cell {
  display: table-cell;
  vertical-align: middle;
}
input::-webkit-input-placeholder {
  color: #999999;
  font-size: $rem32;
  text-align: left;
}
.act-bable {
  background: #f7f7f7;
  width: $rem72;
  height: $rem72;
  padding: $rem16;
  line-height: $rem40;
}
.act-flex1 {
  flex: 1;
}
.act-htg36 {
  width: $rem36;
  height: $rem36;
}
.ui-send {
  font-size: $rem32;
  color: #999999;
  letter-spacing: 0;
  // line-height: $rem72;
  height: $rem72;
  background: #f7f7f7;
  width: 100%;
  padding: $rem8;
}
.ui-sendBtn {
  font-size: $rem32;
  color: #c29451;
  width: $rem96;
  text-align: center;
  p {
    width: 3rem;
    text-align: center;
  }
}
.act-pad88 {
  padding: $rem32;
}
.act-pad18 {
  padding: $rem32;
}

.ui-inputbtn {
  background: #f7f7f7;
  height: 2.25rem;
  padding: 0.5rem 0 0.5rem 0.5rem;
}
</style>
